module.exports = __webpack_public_path__ + "img/03.25c3d963.svg";